import styled, {css, system, SystemProps, themeGetter} from 'quickstart/system'

/**
 * OuterContainer provides padding to avoid bumping up against screen edge.
 */
export const OuterContainer = styled.div<SystemProps & {variant?: 'default'}>(
  ({theme, variant = 'default'}) => {
    const th = themeGetter(theme)
    return css`
      padding-left: ${th(`containers.${variant}.paddings.xs`)};
      padding-right: ${th(`containers.${variant}.paddings.xs`)};

      ${theme.bpKeys.map((bp: string) => {
        const minWidth = th(`breakpoints.${bp}`)
        const padding = th(`containers.${variant}.paddings.${bp}`, null)
        return css`
          @media (min-width: ${minWidth}) {
            padding-left: ${padding};
            padding-right: ${padding};
          }
        `
      })};

      ${system};
    `
  },
)

/**
 * InnerContainer provides max-width. This is separate from OuterContainer so it
 * doesn't need to do extra calculations for the padding.
 */
export const InnerContainer = styled.div<SystemProps & {variant?: 'default'}>(
  ({theme, variant = 'default'}) => {
    const th = themeGetter(theme)
    return css`
      margin-left: auto;
      margin-right: auto;
      max-width: ${th(`containers.${variant}.maxWidths.xs`)};

      ${theme.bpKeys.map((bp: string) => {
        const minWidth = th(`breakpoints.${bp}`)
        const maxWidth = th(`containers.${variant}.maxWidths.${bp}`, null)
        return css`
          @media (min-width: ${minWidth}) {
            max-width: ${maxWidth};
          }
        `
      })};

      ${system};
    `
  },
)
